import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.CompensationSentences;

export const statusSelector = createSelector(rootSelector, (compensationSentences) => compensationSentences.status);

export const errorSelector = createSelector(rootSelector, (compensationSentences) => compensationSentences.error);

export const dataSelector = createSelector(rootSelector, (compensationSentences) => compensationSentences.data);

export default {
  statusSelector,
  errorSelector,
  dataSelector,
};
